/*
i18next setup for the SPA. Three locales — French (default),
English, Spanish — colocated in src/locales. Browser-language
detection seeds the initial value (so a French speaker arriving
on first load still sees French even if the URL hostname is
neutral); subsequent picks are persisted in localStorage so the
user's choice survives reloads.

Adding a new locale is a four-line change: import the resource
file, register it under resources, append it to the
fallbackLng / supportedLngs lists if needed, and add the
matching <option> in the LanguageSwitcher in App.tsx.

Translation strings are organized by feature namespace ("nav",
"auth", "cards", "profile", …). Keys are dot-paths inside each
namespace. Components call useTranslation() with the relevant
namespace(s) at the top of the file.
*/

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { fr } from "../locales/fr";
import { en } from "../locales/en";
import { es } from "../locales/es";

void i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init(
		{
			resources:
			{
				fr,
				en,
				es,
			},
			fallbackLng:		"fr",
			supportedLngs:		["fr", "en", "es"],
			interpolation:		{ escapeValue: false },	// React already escapes
			detection:
			{
				// Persist the user's pick in localStorage so they don't
				// have to re-pick it on every reload; fall back to
				// browser language and finally to the default.
				order:				["localStorage", "navigator"],
				caches:				["localStorage"],
				lookupLocalStorage:	"nfcreader.lang",
			},
		}
	);

export default i18n;
